import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { baseOffersEffects, baseOffersReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('offers', baseOffersReducer.BaseOffersReducer),
    EffectsModule.forFeature([baseOffersEffects.BaseOffersEffects]),
  ],
})
export class BaseOffersStoreModule {}
